module.exports = __webpack_public_path__ + "img/product.7f7e868a.png";